import { render, staticRenderFns } from "./LittleTitle.vue?vue&type=template&id=6565ad14&scoped=true&"
import script from "./LittleTitle.vue?vue&type=script&lang=js&"
export * from "./LittleTitle.vue?vue&type=script&lang=js&"
import style0 from "./LittleTitle.vue?vue&type=style&index=0&id=6565ad14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565ad14",
  null
  
)

export default component.exports